import { useState, useRef, useEffect } from 'react'
import styled from 'styled-components'
import { IoArrowUpOutline } from "react-icons/io5";

const Input = ({ onEnter }: { onEnter: (value: string) => void }) => {
  const [text, setText] = useState('')
  const textAreaRef = useRef<HTMLTextAreaElement>(null)

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleEnter()
    }
  }

  const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setText(e.target.value)
  }

  const handleEnter = () => {
    setText('')
    onEnter(text)
  }

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto'
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`
    }
  }, [text])

  useEffect(() => {
    if (textAreaRef.current) {
      // textAreaRef.current.focus()
    }
  }, [])

  return (
    <Container>
      <TextArea
        ref={textAreaRef}
        rows={1}
        onKeyDown={handleKeyDown}
        onChange={handleTextChange}
        placeholder='Poser une question'
        value={text}
      />
      <Button onClick={handleEnter} disabled={text.length === 0}>
        <IoArrowUpOutline />
      </Button>
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  padding-top: 18px;
  border: 1px solid ${({ theme }) => theme.colorGrey};
  background: var(--site-background);
  // box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1), 0px 0px 12px rgba(0, 0, 0, 0.05);
  border-radius: 30px;
`

const Button = styled.div<{ disabled: boolean }>`
  position: absolute;
  bottom: 15px;
  right: 15px;
  height: 3.3rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${({ theme, disabled }) => disabled ? theme.colorText : theme.colorTextInverted};
  transform: scale(${({disabled}) => disabled ? 0.85 : 1.15});
  opacity: ${({disabled}) => disabled ? 0.25 : 1};
  background: ${({ theme, disabled }) => disabled ? "transparent" : theme.colorText};
  border-radius: 50%;
  transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
  aspect-ratio: 1;
  justify-content: center;
`

const TextArea = styled.textarea`
  flex: 1;
  border: none;
  outline: none;
  font-size: 1.6rem;
  -webkit-font-smoothing: antialiased;
  line-height: 1.4;
  font-family: var(--font-plex);
  resize: none;
  overflow: auto;
  color: ${({ theme }) => theme.colorText};
  background: var(--site-background);

  &::placeholder {
    color: ${({ theme }) => theme.colorGreyDark};
    -webkit-font-smoothing: antialiased;
  }
`

export default Input
